import { render, staticRenderFns } from "./EmailVerify.vue?vue&type=template&id=e06e11e8&scoped=true&"
import script from "./EmailVerify.vue?vue&type=script&lang=js&"
export * from "./EmailVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e11e8",
  null
  
)

export default component.exports